import axios from 'axios'

const Loadcif = (apiUrl, codigoPedido) =>
    axios.post(`${apiUrl}/Transportadora.svc/loadcifsimplificado`, { codigoPedido }, { withCredentials: true }).then((res) => res.data)

const GravarErroCalculoFrete = (apiUrl, erro, pedido, cep) =>
    axios.post(`${apiUrl}/Transportadora.svc/gravaErroFrete`, { erro, pedido, cep }, { withCredentials: true });


export default {
    Loadcif,
    GravarErroCalculoFrete,
}
